import { createSelector } from 'reselect';

import { AnalyticsState } from './types';

export const getAnalyticsState = (state) => state.analytics;

export const selectReportConfiguration = createSelector(
    [getAnalyticsState],
    (analytics: AnalyticsState) => analytics.reportConfiguration
);

export const selectReportConfigurationHasFailed = createSelector(
    [getAnalyticsState],
    (analytics: AnalyticsState) => analytics.isFailed
);

export const selectReportConfigurationIsLoading = createSelector(
    [getAnalyticsState],
    (analytics: AnalyticsState) => analytics.isLoading
);

export const selectAnalyticsOrganizationId = createSelector(
    [getAnalyticsState],
    (analytics: AnalyticsState) => analytics.organizationId
);
